import script from "./FieldBody.vue?vue&type=script&lang=js"
export * from "./FieldBody.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__